import Vue from 'vue';
import styles from '~/assets/style/variables.scss';

export class BaseView extends Vue {
    constructor() {
        super();
    }

    isLoading = false;

    protected get componentName(): string {
        return this.constructor.name;
    }

    touch() {
        this.$v.$touch();
    }

    async doValidate() {
        this.$v.$touch();
        if (this.$v.$invalid) {
            return false;
        }
        return true;
    }

    get isInvalid() {
        return this.$v.$invalid && this.$v.$dirty;
    }

    get isDisableButton() {
        return this.$v.$invalid;
    }
}
